import { Component, OnInit } from '@angular/core';
import { Toast } from 'src/app/shared/models/signature.model';
import { ToastBehaviorService } from 'src/app/services/behavior/toast-behavior.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

  title!:string;
  body!:string;
  valid:string = 'bg-success'

  constructor(
    private readonly toast: ToastBehaviorService
  ) { }

  ngOnInit(): void {
    this.toast.get.subscribe((toast:Toast) => {
      this.body = toast.body
      this.valid = toast.valid
    });

  }

}
